import { render, staticRenderFns } from "./SInputBase.vue?vue&type=template&id=1b7f23be&scoped=true&"
import script from "./SInputBase.vue?vue&type=script&lang=ts&"
export * from "./SInputBase.vue?vue&type=script&lang=ts&"
import style0 from "./SInputBase.vue?vue&type=style&index=0&id=1b7f23be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f23be",
  null
  
)

export default component.exports